import React from 'react';

interface ReloadButtonProps {
  onClick?: () => void;
}

const ReloadButton = ({ onClick }: ReloadButtonProps) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      window.location.reload();
    }
  };

  return (
    <button type="button" className="reload-button" onClick={handleClick}>
      Reload Page
    </button>
  );
};

export default ReloadButton;
